import React from 'react';
import { Globe } from 'lucide-react';

// Curated list of major travel-relevant countries grouped roughly by region
// for an asymmetric "world stamp wall" — not a true map, but emotional + lightweight.
const COUNTRIES = [
  // Europe
  { cc: 'gb', name: 'UK',     flag: '🇬🇧' },
  { cc: 'ie', name: 'Ireland',flag: '🇮🇪' },
  { cc: 'fr', name: 'France', flag: '🇫🇷' },
  { cc: 'es', name: 'Spain',  flag: '🇪🇸' },
  { cc: 'pt', name: 'Portugal', flag: '🇵🇹' },
  { cc: 'it', name: 'Italy',  flag: '🇮🇹' },
  { cc: 'de', name: 'Germany',flag: '🇩🇪' },
  { cc: 'ch', name: 'Switz.', flag: '🇨🇭' },
  { cc: 'at', name: 'Austria',flag: '🇦🇹' },
  { cc: 'nl', name: 'NL',     flag: '🇳🇱' },
  { cc: 'be', name: 'Belgium',flag: '🇧🇪' },
  { cc: 'no', name: 'Norway', flag: '🇳🇴' },
  { cc: 'se', name: 'Sweden', flag: '🇸🇪' },
  { cc: 'dk', name: 'Denmark',flag: '🇩🇰' },
  { cc: 'fi', name: 'Finland',flag: '🇫🇮' },
  { cc: 'is', name: 'Iceland',flag: '🇮🇸' },
  { cc: 'gr', name: 'Greece', flag: '🇬🇷' },
  { cc: 'tr', name: 'Türkiye',flag: '🇹🇷' },
  { cc: 'pl', name: 'Poland', flag: '🇵🇱' },
  { cc: 'cz', name: 'Czechia',flag: '🇨🇿' },
  { cc: 'hu', name: 'Hungary',flag: '🇭🇺' },
  // Americas
  { cc: 'us', name: 'USA',    flag: '🇺🇸' },
  { cc: 'ca', name: 'Canada', flag: '🇨🇦' },
  { cc: 'mx', name: 'Mexico', flag: '🇲🇽' },
  { cc: 'br', name: 'Brazil', flag: '🇧🇷' },
  { cc: 'ar', name: 'Argentina', flag: '🇦🇷' },
  // Asia
  { cc: 'jp', name: 'Japan',  flag: '🇯🇵' },
  { cc: 'kr', name: 'Korea',  flag: '🇰🇷' },
  { cc: 'cn', name: 'China',  flag: '🇨🇳' },
  { cc: 'in', name: 'India',  flag: '🇮🇳' },
  { cc: 'th', name: 'Thailand', flag: '🇹🇭' },
  { cc: 'vn', name: 'Vietnam',flag: '🇻🇳' },
  { cc: 'id', name: 'Indonesia', flag: '🇮🇩' },
  { cc: 'ph', name: 'PH',     flag: '🇵🇭' },
  { cc: 'sg', name: 'S\'pore',flag: '🇸🇬' },
  { cc: 'my', name: 'Malaysia',flag:'🇲🇾' },
  { cc: 'ae', name: 'UAE',    flag: '🇦🇪' },
  // Oceania
  { cc: 'au', name: 'Australia', flag: '🇦🇺' },
  { cc: 'nz', name: 'NZ',     flag: '🇳🇿' },
  // Africa
  { cc: 'eg', name: 'Egypt',  flag: '🇪🇬' },
  { cc: 'ma', name: 'Morocco',flag: '🇲🇦' },
  { cc: 'za', name: 'S Africa', flag: '🇿🇦' },
  { cc: 'ke', name: 'Kenya',  flag: '🇰🇪' },
];

export default function PassportMap({ visitedCountryCodes = [] }) {
  const visited = new Set((visitedCountryCodes || []).map(c => (c || '').toLowerCase()));

  return (
    <div className="puvio-card p-5" data-testid="passport-map">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="font-bold text-[10.5px] uppercase tracking-[0.22em] text-[#15291C] flex items-center gap-1.5">
            <Globe className="w-3 h-3" /> Passport map
          </p>
          <p className="text-xs text-[#7A8A80] mt-0.5 font-medium">{visited.size} of {COUNTRIES.length} curated stamps</p>
        </div>
        <span className="px-2.5 py-1 rounded-full bg-gradient-to-r from-[#15291C] to-[#1F3A29] text-[#0F1A13] text-[10.5px] font-bold">{visited.size}🛂</span>
      </div>
      <div className="grid grid-cols-7 gap-1.5">
        {COUNTRIES.map(c => {
          const ok = visited.has(c.cc);
          return (
            <div
              key={c.cc}
              title={c.name}
              data-testid={`passport-${c.cc}`}
              className={`relative aspect-square rounded-xl flex flex-col items-center justify-center gap-0.5 transition-all ${ok
                ? 'bg-gradient-to-br from-[#C4FF3D]/35 to-[#C4FF3D]/15 border border-[#15291C]/25 shadow-[0_0_12px_rgba(196,255,61,0.30)]'
                : 'bg-[#F2F0E4]/40 border border-[#0F1A13]/06 grayscale opacity-45'}`}
            >
              <span className="text-[14px] leading-none">{c.flag}</span>
              <span className={`text-[8px] uppercase tracking-tight ${ok ? 'text-[#15291C] font-bold' : 'text-[#7A8A80]'}`}>{c.name.length > 6 ? c.name.slice(0, 6) : c.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
